/*
 * Theme tokens now come from the shared design system, @atomic/ui-kit — one
 * source of truth shared with chomps. This is a thin re-export shim: every
 * existing `import { theme, alpha } from ".../styles"` (or ".../styles/theme/theme")
 * keeps working unchanged. The tokens.css that backs these var() references is
 * also the package's (see ./tokens.css).
 */
export { theme, alpha, type Theme } from "@atomic/ui-kit"
